module.exports = __webpack_public_path__ + "media/images/gfx/reset_password_xs_disabled-e0fa213a15dd4bf6cf0cb6bf2c2bca82.gif";